import { useBlockPageOverflow } from '@App/hooks/useBlockPageOverflow'
import { Calendar } from './components/Calendar'
import s from './styles.module.scss'

export const CalendarPage = () => {
  useBlockPageOverflow()
  return <Calendar />
}
